import { MutableRefObject, useEffect } from 'react';

export const useOutsideClick = (
  ref: MutableRefObject<Element | null>,
  callback: () => void
): void => {
  const handleClick = (e: MouseEvent): void => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      callback();
    }
  };

  useEffect((): (() => void) => {
    document.addEventListener('click', handleClick);
    return (): void => {
      document.removeEventListener('click', handleClick);
    };
  });
};
